/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  CellularV2MintPlansDestroyPathParameters,
  CellularV2MintPlansListParams,
  CellularV2MintPlansPartialUpdatePathParameters,
  CursorPaginatedMintPlanResponseV2,
  MintPlanCreateRequestV2Request,
  MintPlanResponseV2,
  PatchedMintPlanPatchRequestV2Request
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class CellularMintPlanService {
  private readonly http = inject(HttpClient);
/**
 * Admin-only. Returns MintPlan rows ordered by `id`. Defaults to `active=True` only; pass `?include_inactive=true` to include soft-retired plans.
 * @summary List Mint tariff plans (cursor-paginated).
 */
 cellularV2MintPlansList<TData = CursorPaginatedMintPlanResponseV2>(params?: CellularV2MintPlansListParams, options?: HttpClientBodyOptions): Observable<TData>;
 cellularV2MintPlansList<TData = CursorPaginatedMintPlanResponseV2>(params?: CellularV2MintPlansListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 cellularV2MintPlansList<TData = CursorPaginatedMintPlanResponseV2>(params?: CellularV2MintPlansListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  cellularV2MintPlansList<TData = CursorPaginatedMintPlanResponseV2>(
    params?: CellularV2MintPlansListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v2/cellular/mint_plans/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v2/cellular/mint_plans/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v2/cellular/mint_plans/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Admin-only. New plans land `active=True`. Retire via `PATCH active=false`, not DELETE (the latter is refused with 409 if any SIM card references the plan).
 * @summary Create a Mint tariff plan.
 */
 cellularV2MintPlansCreate<TData = MintPlanResponseV2>(mintPlanCreateRequestV2Request: MintPlanCreateRequestV2Request, options?: HttpClientBodyOptions): Observable<TData>;
 cellularV2MintPlansCreate<TData = MintPlanResponseV2>(mintPlanCreateRequestV2Request: MintPlanCreateRequestV2Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 cellularV2MintPlansCreate<TData = MintPlanResponseV2>(mintPlanCreateRequestV2Request: MintPlanCreateRequestV2Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  cellularV2MintPlansCreate<TData = MintPlanResponseV2>(
    mintPlanCreateRequestV2Request: MintPlanCreateRequestV2Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v2/cellular/mint_plans/`,
      mintPlanCreateRequestV2Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v2/cellular/mint_plans/`,
      mintPlanCreateRequestV2Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v2/cellular/mint_plans/`,
      mintPlanCreateRequestV2Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Only fields present in the body are written; omitted fields keep their stored value. To soft-retire a plan, send `{"active": false}` — that is the intended alternative to DELETE.
 * @summary Partial-update a Mint tariff plan (preserve-on-omit).
 */
 cellularV2MintPlansPartialUpdate<TData = MintPlanResponseV2>(pathParams: CellularV2MintPlansPartialUpdatePathParameters,
    patchedMintPlanPatchRequestV2Request?: PatchedMintPlanPatchRequestV2Request, options?: HttpClientBodyOptions): Observable<TData>;
 cellularV2MintPlansPartialUpdate<TData = MintPlanResponseV2>(pathParams: CellularV2MintPlansPartialUpdatePathParameters,
    patchedMintPlanPatchRequestV2Request?: PatchedMintPlanPatchRequestV2Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 cellularV2MintPlansPartialUpdate<TData = MintPlanResponseV2>(pathParams: CellularV2MintPlansPartialUpdatePathParameters,
    patchedMintPlanPatchRequestV2Request?: PatchedMintPlanPatchRequestV2Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  cellularV2MintPlansPartialUpdate<TData = MintPlanResponseV2>(
    { identity }: CellularV2MintPlansPartialUpdatePathParameters,
    patchedMintPlanPatchRequestV2Request?: PatchedMintPlanPatchRequestV2Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/v2/cellular/mint_plans/${identity}/`,
      patchedMintPlanPatchRequestV2Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/v2/cellular/mint_plans/${identity}/`,
      patchedMintPlanPatchRequestV2Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/v2/cellular/mint_plans/${identity}/`,
      patchedMintPlanPatchRequestV2Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Refused with 409 `/problems/mint-plan-in-use` if any SimCard still references the plan — soft-retire via `PATCH active=false` instead. Succeeds with 204 (no body) when the plan has zero assigned SIMs.
 * @summary Hard-delete a Mint tariff plan.
 */
 cellularV2MintPlansDestroy<TData = void>(pathParams: CellularV2MintPlansDestroyPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 cellularV2MintPlansDestroy<TData = void>(pathParams: CellularV2MintPlansDestroyPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 cellularV2MintPlansDestroy<TData = void>(pathParams: CellularV2MintPlansDestroyPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  cellularV2MintPlansDestroy<TData = void>(
    { identity }: CellularV2MintPlansDestroyPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v2/cellular/mint_plans/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v2/cellular/mint_plans/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v2/cellular/mint_plans/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type CellularV2MintPlansListClientResult = NonNullable<CursorPaginatedMintPlanResponseV2>
export type CellularV2MintPlansCreateClientResult = NonNullable<MintPlanResponseV2>
export type CellularV2MintPlansPartialUpdateClientResult = NonNullable<MintPlanResponseV2>
export type CellularV2MintPlansDestroyClientResult = NonNullable<void>
